// assets/upside-unit-price.js
// Simon 2026-10-02: price per 100 ml (Amazon style) + calories and sugar per 100 ml.
// - Collection cards (rendered client-side by Globo): "($1.60 / 100 ml)" next to the price
//   (own line on mobile) and one chip "33 cal · 7 g sugar / 100 ml" (green at 0 g sugar).
//   2026-10-08: chip per 45 ml on spirits, per 30 ml on syrups, per 100 ml on everything else.
// - Product page: price per 100 ml under the price, plus the saving per ml against the single.
// Volumes and nutrition come from assets/upside-card-facts.json, regenerated every day by
// 1_upside-drinks/tools/nutrition-facts/scripts/card_facts.mjs (Globo does not expose our
// metafields to its cards). Pack count is read from the variant title ("24 Pack", "1 Can (355ml)").
(function () {
  'use strict';
  if (window.__UD_UNIT_PRICE__) return;
  window.__UD_UNIT_PRICE__ = true;

  var me = document.currentScript;
  var FACTS_URL = me && me.getAttribute('data-facts');
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var facts = null;

  // A/B test (Simon 2026-10-08, compare ~2026-11-08): A = calories/sugar chip shown, B = no chip.
  // 50/50 per visitor, kept in localStorage; ?udchip=a|b forces a group (QA). Every cart gets the
  // hidden attribute _chip_ab so each order says which group it came from.
  var AB = (function () {
    var g = null, m = location.search.match(/[?&]udchip=(a|b)\b/i);
    try { g = m ? m[1].toUpperCase() : localStorage.getItem('ud_chip_ab'); } catch (e) {}
    if (g !== 'A' && g !== 'B') g = Math.random() < 0.5 ? 'A' : 'B';
    try { localStorage.setItem('ud_chip_ab', g); } catch (e) {}
    return g;
  })();
  window.UD_CHIP_AB = AB;
  var abBusy = false;
  function abSync() {
    if (abBusy) return; abBusy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || !c.item_count || (c.attributes && c.attributes._chip_ab === AB)) return;
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _chip_ab: AB } }) });
    }).catch(function () {}).then(function () { abBusy = false; });
  }
  try {
    setTimeout(abSync, 1500);
    new PerformanceObserver(function (l) {
      l.getEntries().forEach(function (e) { if (/\/cart\/(add|change)/.test(e.name)) setTimeout(abSync, 800); });
    }).observe({ entryTypes: ['resource'] });
  } catch (e) {}

  var css = [
    // Simon 2026-10-02: very small, grey, neutral font. The theme sizes every span in the price, hence !important
    '.grid-product .grid-product__price .ud-unit{font-family:Arial,Helvetica,sans-serif !important;font-size:11px !important;line-height:1.2;color:#9aa0a6 !important;font-weight:400 !important;margin-left:5px;white-space:nowrap;letter-spacing:0;vertical-align:1px}',
    '.ud-chip{display:inline-block;margin:5px auto 0;font-size:11px;line-height:1.3;font-weight:600;color:#37446E;background:#eef1f7;border-radius:10px;padding:3px 9px}',
    '.ud-chip--zero{color:#1c7c3c;background:#e7f6ec}',
    // Simon 2026-10-08: Zoomy wishlist heart top RIGHT of the card photo (was top left, read as the previous card's)
    '.grid-product .grid-product__actions .zoomywishid,.grid-product .zoomywishid{left:auto !important;right:8px !important;top:6px !important;width:auto !important;float:none !important;z-index:5}',
    '.ud-chip-wrap{text-align:center}',
    '.ud-unit-pdp{font-family:Arial,Helvetica,sans-serif;font-size:12px;line-height:1.4;color:#8a8f98;margin-top:4px;width:100%}',
    '.ud-unit-pdp .ud-save{color:#1c7c3c}',
    '.ud-pills{display:flex;flex-wrap:wrap;gap:4px;justify-content:flex-end;flex:0 0 auto;order:99;margin-left:auto}',
    '.ud-pill{font-family:Arial,Helvetica,sans-serif;font-size:11px;line-height:1;padding:5px 8px;border:1px solid #d6d9e0;border-radius:12px;background:#fff;color:#37446E;cursor:pointer;white-space:nowrap}',
    '.ud-pill.is-on{background:#37446E;border-color:#37446E;color:#fff}',
    '@media (max-width:768px){.ud-pills{justify-content:flex-start;margin-left:26px;flex:1 1 100%}}',
    '.ud-unit-pdp .ud-chip{margin-top:8px;font-family:inherit}',
    '@media (max-width:768px){.grid-product .grid-product__price .ud-unit{display:block;margin-left:0;margin-top:1px;vertical-align:0}.ud-chip{font-size:10.5px;padding:3px 7px}}'
  ].join('');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function money(n) { return '$' + n.toFixed(2); }
  function dec(n) {
    var r = Math.round(n * 10) / 10;
    var s = (r % 1 === 0) ? String(r) : r.toFixed(1);
    return FR ? s.replace('.', ',') : s;
  }
  function packCount(title) {
    var t = String(title || '').toLowerCase().trim();
    if (!t || t === 'default title') return 1;
    if (/^1\s*(can|bottle|canette|bouteille)\b/.test(t)) return 1;
    if (/^\d+(\.\d+)?\s*l\s*box/.test(t)) return 1;
    var m = t.match(/^(\d+)\s*x\s/) || t.match(/^(\d+)\s*(pack|bottles?|cans?|canettes?|bouteilles?)\b/);
    return m ? parseInt(m[1], 10) : null;
  }
  function parsePrice(text) {
    var m = String(text || '').replace(/\s/g, '').match(/(\d+)[.,](\d{2})/);
    return m ? parseFloat(m[1] + '.' + m[2]) : null;
  }
  function per100(price, n, ml) { return price / (n * ml) * 100; }
  function unitText(u) { return money(u) + ' / 100 ml'; }

  function chipHtml(f) {
    // f = [ml, cal100, sugar100, noChip, popularVariant, servingMl]
    // Simon 2026-10-08: spirits per 45 ml, syrups per 30 ml (servingMl set by card_facts.mjs), the rest per 100 ml.
    if (f[3] || AB === 'B') return '';
    var k = f[5] ? f[5] / 100 : 1;
    var cal = f[1] == null ? null : f[1] * k, sug = f[2] == null ? null : f[2] * k;
    if (cal == null && sug == null) return '';
    var parts = [];
    if (cal != null) parts.push(Math.round(cal) + ' cal');
    if (sug != null) parts.push(dec(sug) + (FR ? ' g de sucre' : ' g sugar'));
    var zero = sug != null && Math.round(sug * 10) === 0;
    return '<span class="ud-chip' + (zero ? ' ud-chip--zero' : '') + '">' + parts.join(' &middot; ') + ' / ' + (f[5] || 100) + ' ml</span>';
  }

  // ---------- collection cards ----------
  function doCard(card) {
    var f = facts[card.getAttribute('data-product-handle')];
    if (!f) return;
    var priceEl = card.querySelector('.grid-product__price');
    if (!priceEl) return;
    var shown = priceEl.querySelector('.visually-hidden');
    var price = parsePrice(shown ? shown.textContent : priceEl.textContent);
    // Which variant is the shown price? Take the select option at that price, else the cheapest.
    var opts = card.querySelectorAll('select[name="id"] option');
    var best = null;
    for (var i = 0; i < opts.length; i++) {
      var txt = opts[i].textContent;
      var cut = txt.lastIndexOf(' - ');
      var title = cut > 0 ? txt.slice(0, cut) : txt;
      var p = parsePrice(cut > 0 ? txt.slice(cut) : '');
      var n = packCount(title);
      if (p == null || !n) continue;
      if (price != null && Math.abs(p - price) < 0.005) { best = { p: p, n: n }; break; }
      if (!best || p < best.p) best = { p: p, n: n };
    }
    if (!best && price != null) {
      var w = card.querySelector('[data-variantname]');
      var n1 = packCount(w ? w.getAttribute('data-variantname') : '');
      if (n1) best = { p: price, n: n1 };
    }
    var unit = priceEl.querySelector('.ud-unit');
    if (best) {
      var txtU = '(' + unitText(per100(best.p, best.n, f[0])) + ')';
      if (!unit) {
        unit = document.createElement('span');
        unit.className = 'ud-unit';
        priceEl.appendChild(unit);
      }
      if (unit.textContent !== txtU) unit.textContent = txtU;
    }
    // Simon 2026-10-08: green "Sugar-free" pill on the photo for wines at 0 g sugar (facts[7], set by card_facts.mjs).
    // Same pill style as the mood / Better-for-you pill (ud-card-moods.js). Shown in both chip A/B groups.
    if (f[7] && !card.querySelector('.ud-sf-tag')) {
      var tags = card.querySelector('.grid-product__tags');
      if (!tags) {
        var iw = card.querySelector('.grid-product__image-wrap');
        if (iw) { tags = document.createElement('div'); tags.className = 'grid-product__tags'; iw.appendChild(tags); }
      }
      if (tags) {
        var sf = document.createElement('div');
        sf.className = 'grid-product__tag grid-product__tag--custom ud-mood-tag ud-sf-tag';
        sf.style.cssText = 'background:#e7f6ec !important;color:#1c7c3c !important';
        sf.innerHTML = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M24 40c-9-4-14-11-14-20 7 0 11 3 14 8 3-5 7-8 14-8 0 9-5 16-14 20z"/><path d="M24 40V28"/></svg>';
        sf.appendChild(document.createTextNode(FR ? 'Sans sucre' : 'Sugar-free'));
        tags.appendChild(sf);
      }
    }
    if (!card.querySelector('.ud-chip-wrap')) {
      var html = chipHtml(f);
      if (html) {
        var wrap = document.createElement('div');
        wrap.className = 'ud-chip-wrap';
        wrap.innerHTML = html;
        priceEl.parentNode.insertBefore(wrap, priceEl.nextSibling);
      }
    }
  }
  // Rebuy cart drawer bar said "$79 (ON/QC), $129 (West), $149 (Atlantic)" in EN and "+145$+" in FR.
  // Real thresholds since 2026-10-08: $75 ON/QC, $125 AB/BC/MB/SK, $150 NB/NS/PE/NL. Fix it in Rebuy admin too (Smart Cart > announcement).
  function fixCartBar() {
    var txt = FR ? 'QC et ON : livraison gratuite dès 75 $ | Ouest dès 125 $ | Atlantique dès 150 $'
                 : 'ON & QC: free shipping on $75+ | West: $125+ | Atlantic: $150+';
    var els = document.querySelectorAll('.rebuy-cart__flyout-announcement-bar-message');
    for (var i = 0; i < els.length; i++) {
      if (/(75|79|125|129|145|149|150)/.test(els[i].textContent) && els[i].textContent.trim() !== txt) els[i].textContent = txt;
    }
  }
  function scanCards() {
    try { doFbt(); } catch (e) {}
    try { fixCartBar(); } catch (e) {}
    var cards = document.querySelectorAll('.grid-product[data-product-handle]');
    for (var i = 0; i < cards.length; i++) {
      try { doCard(cards[i]); } catch (e) {}
    }
  }

  // ---------- Frequently Bought Together (Rebuy bundle) ----------
  // Simon 2026-10-02: one click, no choices. Each added product gets its most popular
  // variant (facts[handle][4], last 90 days of orders); the dropdowns are hidden by CSS
  // in templates/product.json (block fbt_compact_css). "This item" keeps the page's choice.
  function doFbt() {
    // Simon 2026-10-02: dropdown hidden, small size pills instead ("24 Pack | 6 Pack | 1 Can")
    var all = document.querySelectorAll('.rebuy-bundle .rebuy-product-block');
    for (var j = 0; j < all.length; j++) {
      var s0 = all[j].querySelector('select');
      var info = all[j].querySelector('.rebuy-product-info');
      if (!s0 || !info || s0.options.length < 1) continue;
      var key = s0.value + '|' + s0.options.length;
      var box = all[j].querySelector('.ud-pills');
      if (box && box.getAttribute('data-k') === key) continue;
      if (!box) { box = document.createElement('div'); box.className = 'ud-pills'; info.parentNode.insertBefore(box, info.nextSibling); }
      box.setAttribute('data-k', key);
      box.innerHTML = '';
      for (var k = 0; k < s0.options.length; k++) {
        var o = s0.options[k];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ud-pill' + (o.value === s0.value ? ' is-on' : '');
        btn.textContent = o.textContent.replace(/\s*\(.*?\)\s*/g, ' ').trim();
        btn.setAttribute('data-v', o.value);
        btn.addEventListener('click', function (ev) {
          ev.preventDefault();
          var sel = ev.currentTarget.closest('.rebuy-product-block').querySelector('select');
          sel.value = ev.currentTarget.getAttribute('data-v');
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          setTimeout(doFbt, 30);
        });
        box.appendChild(btn);
      }
    }
    var blocks = document.querySelectorAll('.rebuy-bundle .rebuy-product-block:not(.is-input-product)');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (b.getAttribute('data-ud-pop')) continue;
      var handle = b.classList[1];
      var f = facts[handle];
      var sel = b.querySelector('select.rebuy-select, select');
      if (!f || !f[4] || !sel) continue;
      b.setAttribute('data-ud-pop', '1');
      var want = String(f[4]);
      if (sel.value === want) continue;
      for (var k = 0; k < sel.options.length; k++) {
        if (sel.options[k].value === want) {
          sel.value = want;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          break;
        }
      }
    }
  }

  // ---------- product page ----------
  var pdp = null;
  function initPdp() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    var f = facts[handle];
    if (!f) return;
    var priceEl = document.querySelector('.product-block--price [data-product-price]');
    if (!priceEl) return;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (prod) {
      pdp = { f: f, prod: prod, priceEl: priceEl, block: priceEl.closest('.product-block--price') };
      renderPdp();
      new MutationObserver(renderPdp).observe(priceEl, { childList: true, subtree: true, characterData: true });
      document.addEventListener('change', function () { setTimeout(renderPdp, 50); }, true);
    }).catch(function () {});
  }
  function currentVariant() {
    var prod = pdp.prod, id = null;
    var form = pdp.block && pdp.block.closest('form');
    var sec = pdp.block && (pdp.block.closest('[data-section-type]') || document);
    var inp = (form && form.querySelector('[name="id"]')) || (sec && sec.querySelector('form[action*="/cart/add"] [name="id"]'));
    if (inp && inp.value) id = parseInt(inp.value, 10);
    if (!id) { var q = new URLSearchParams(location.search).get('variant'); if (q) id = parseInt(q, 10); }
    for (var i = 0; i < prod.variants.length; i++) if (prod.variants[i].id === id) return prod.variants[i];
    return prod.variants[0];
  }
  function renderPdp() {
    if (!pdp) return;
    var v = currentVariant();
    var n = packCount(v.title);
    var shown = pdp.priceEl.querySelector('.visually-hidden');
    var price = parsePrice(shown ? shown.textContent : pdp.priceEl.textContent);
    if (price == null) price = v.price / 100;
    var el = pdp.block.querySelector('.ud-unit-pdp');
    if (!n) { if (el) el.remove(); return; }
    var u = per100(price, n, pdp.f[0]);
    var txt = unitText(u);
    if (n > 1) {
      var single = null;
      for (var i = 0; i < pdp.prod.variants.length; i++) {
        if (packCount(pdp.prod.variants[i].title) === 1) { single = pdp.prod.variants[i]; break; }
      }
      if (single) {
        var save = Math.round((1 - u / per100(single.price / 100, 1, pdp.f[0])) * 100);
        if (save >= 3) {
          var st = String(single.title).toLowerCase();
          var kind = /can|canette/.test(st) ? 'can' : (/bottle|bouteille/.test(st) ? 'bottle' : '');
          var than = FR
            ? (kind === 'can' ? " qu'une canette" : kind === 'bottle' ? " qu'une bouteille" : " qu'à l'unité")
            : (kind ? ' than 1 ' + kind : ' than single');
          txt += ' &middot; <span class="ud-save">' + save + (FR ? ' % moins cher' : '% lower') + than + '</span>';
        }
      }
    }
    var chip = chipHtml(pdp.f);
    if (chip) txt += '<br>' + chip;
    if (!el) {
      el = document.createElement('div');
      el.className = 'ud-unit-pdp';
      pdp.block.appendChild(el);
    }
    if (el.getAttribute('data-k') !== txt) { el.innerHTML = txt; el.setAttribute('data-k', txt); }
  }

  // ---------- boot ----------
  function start() {
    scanCards();
    initPdp();
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; scanCards(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (!FACTS_URL) return;
  fetch(FACTS_URL).then(function (r) { return r.json(); }).then(function (d) {
    facts = d;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }).catch(function () {});
})();
